// @flow

import PubSub from "./util/pubsub";
import { events } from "./site-overlay";

type ContainerType = {
    link: HTMLElement,
    submenu: HTMLElement,
};

class PrimaryNav {
    el: HTMLElement;
    currentOpenSubmenu: ?ContainerType;
    submenuContainers: Array<ContainerType>;

    constructor(el: HTMLElement) {
        this.el = el;
        this.currentOpenSubmenu = null;

        // Populate with an array of objects with structure: { link, submenu }
        this.submenuContainers = Array.from(
            el.querySelectorAll(".primary-nav__menu__item--has-submenu")
        ).reduce(
            (
                prev: Array<ContainerType>,
                current: HTMLElement
            ): Array<ContainerType> => {
                const link = current.querySelector(".primary-nav__menu__link");
                const submenu = current.querySelector(".nav-submenu");
                if (!link || !submenu) {
                    return prev;
                }
                return [
                    ...prev,
                    {
                        link,
                        submenu,
                    },
                ];
            },
            []
        );

        this.attachHandlers();
    }

    attachHandlers = () => {
        // Menu closable with escape
        window.addEventListener("keyup", (event: KeyboardEvent) => {
            if (event.key === "Escape" && this.currentOpenSubmenu) {
                this.closeSubmenu(this.currentOpenSubmenu);
            }
        });

        // Menu closable by clicking outside
        window.addEventListener("click", (event: KeyboardEvent) => {
            if (
                this.currentOpenSubmenu &&
                !this.el.contains((event.target: any))
            ) {
                this.closeSubmenu(this.currentOpenSubmenu);
            }
        });

        // Toggle submenus on parent click
        this.submenuContainers.forEach((container: ContainerType) => {
            container.link.addEventListener("click", (event: Event) => {
                event.preventDefault();
                this.toggleSubmenu(container);
            });
        });
    };

    toggleSubmenu = (container: ContainerType) => {
        if (container.link.getAttribute("aria-expanded") === "true") {
            this.closeSubmenu(container);
        } else {
            if (this.currentOpenSubmenu) {
                this.closeSubmenu(this.currentOpenSubmenu);
            }
            this.openSubmenu(container);
        }
    };

    openSubmenu = (container: ContainerType) => {
        PubSub.publish(events.show);
        container.link.setAttribute("aria-expanded", "true");
        container.submenu.setAttribute("aria-expanded", "true");
        container.submenu.setAttribute("aria-hidden", "false");
        this.currentOpenSubmenu = container;
    };

    closeSubmenu = (container: ContainerType) => {
        PubSub.publish(events.hide);
        container.link.setAttribute("aria-expanded", "false");
        container.submenu.setAttribute("aria-expanded", "false");
        container.submenu.setAttribute("aria-hidden", "true");
        this.currentOpenSubmenu = null;
    };
}

const el = document.querySelector(".primary-nav__menu");
if (el) {
    new PrimaryNav(el);
}
